import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const useStopDataDogSessionRecording = () => {
  useEffect(() => {
    const handleTabClose = () => {
      datadogRum.stopSessionReplayRecording();
    };

    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, []);
};
